import panel from './panel'
import smPanel from './smPanel'
import page from './page'
import modal from './modal'
import select from './select'
import file from './file'
import printTable from './printSwiperSlidesTable'
export default { panel, smPanel, page, modal, select, file, printTable }



// WEBPACK FOOTER //
// ./src/components/index.js